import type { ChatItem } from 'ts-components/PiChat/reducer';

// Format from pi-poc src/core/tools.ts: "Pushed: created dashlet <id>"
export const parsePushSummary = (
  item: Pick<
    Extract<ChatItem, { kind: 'tool' }>,
    'toolName' | 'status' | 'summary'
  >
): { action: 'created' | 'updated' } | null => {
  if (item.toolName !== 'push_block' || item.status !== 'ok') return null;
  const match = /^Pushed: (created|updated)\b/.exec(item.summary);
  return match ? { action: match[1] as 'created' | 'updated' } : null;
};
